class Transfer {
    transferId = 0;
    createdBy = 0;
    toAccountId = 0;
    fromAccountId = 0;
    amount = 0;
    transferDescription = "";
    transferStatus = 0;
    transferType = 0;
    confirmationNumber = "";
    creationDate = 0;
    currency = "";
    guid = "";
    dataJson = "";

    constructor(data = {}) {
        Object.assign(this, data);
    }

    getCreationDate() {
        return new Date(this.creationDate);
    }

    getDataJson() {
        console.log("dataJson", this.dataJson);
        try {
            if (this.dataJson) {
                return JSON.parse(this.dataJson);
            } else {
                return {};
            }
        }catch(err){
            console.error("Error parsing dataJson", err, this.dataJson);

            return {};
        }
    }

    getStatusStr() {
        switch (this.transferStatus) {
            case 0: return "invalid";
            case 1: return "pending";
            case 2: return "completed";
            case 3: return "declined";
            case 4: return "cancelledByEndUser";
            case 5: return "cancelledByPartner";
            case 6: return "cancelledByMerchant";
            case 7: return "cancelledByAdmin";
            case 8: return "closed";
            case 9: return "all";
            default: return "n/a";
        }
    }

    getTypeStr() {
        switch (this.transferType) {
            case 0: return "invalid";
            case 1: return "credit";
            case 2: return "debit";
            case 3: return "winning";
            case 4: return "tourneyFee";
            case 5: return "refund";
            case 6: return "withdrawal";
            case 7: return "deposit";
            case 8: return "all";
            default: return "n/a";
        }
    }

    isDeposit(userAccountId) {
        return this.toAccountId === userAccountId;
    }

    static fromJson(data) {
        return new Transfer(data);
    }
}

export default Transfer;
